/**
 * 
 * Main Menu Toggle
 * 
 */

var menu_toggle = document.getElementById('js-menu-toggle');
var menu_overlay = document.getElementById('js-menu-overlay');

function toggleMenu() {
    menu_toggle.classList.toggle('active');
    menu_overlay.classList.toggle('open');
}

menu_toggle.addEventListener('click', function(event) {
    toggleMenu(); 
    event.stopPropagation();
});

// Close the menu if clicked outside
document.addEventListener('click', function(event) {
    if (!menu_overlay.contains(event.target) && !menu_toggle.contains(event.target) && menu_overlay.classList.contains('open')) {
        toggleMenu();
    }
});

// Prevents the menu overlay click from closing itself
menu_overlay.addEventListener('click', function(event) {
    event.stopPropagation();
});



/**
 * 
 * Active On: Floor Plans Page
 * Action: Toggle Availablity Table
 * 
 */

var avail_toggle = document.querySelector('#js-avail-toggle');


if (avail_toggle) {
        avail_toggle.addEventListener('click', function() {
        this.classList.toggle('active');
        
        var availability = document.querySelector('#js-availability');
        availability.classList.toggle('open');
    });
  }



 /**
 * 
 * Active On: Neighborhood Page
 * Action: Control Map Legend Buttons
 * 
 */ 

jQuery(document).ready(function($) {
    $('.js-map-cat-filter').click(function() {
        // Get the category ID from the clicked filter
        var categoryId = $(this).data('category'); 
        var checkboxId = 'wpgmza_cat_checkbox_' + categoryId;
        $('#' + checkboxId).click();

        //Add active class to the clicked filter button and remove from previously clicked button
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('#js-category-title').text(''); // Clear the label text if the filter is deactivated
        } else {
            $('.js-map-cat-filter').removeClass('active');
            $(this).addClass('active');

            // Set the text of title element
            var label = $(this).text(); // Assuming the text you want to display is the text of the button
            $('#js-category-title').text(label);

        }
    });

    $('.wpgmza_checkbox').on('click', function() {
        $('.wpgmza_checkbox').not(this).prop('checked', false);
    });
});



